class SemiAutomaticFiring {
    name;
    shortName;
    fireLimit;
    bulletsFired;
    /**
     * Logic for semi-automatic gun firing.
     */
    constructor() {
        this.name = "Semi-automatic";
        this.shortName = "semi";
        this.bulletsFired = 0;
        this.fireLimit = 1;
    }
    /**
     * Increase the amount of bullets fired counter after a shot.
     */
    onShoot() {
        this.bulletsFired += 1;
    }
    /** Reset the amount of bullets fired counter when the player stops shooting. */
    onStopShooting() {
        this.bulletsFired = 0;
    }
    /**
     * Check whether the gun can fire or not.
     * @returns A boolean indicating whether the gun can be fired or not.
     */
    get canFire() {
        return this.bulletsFired < this.fireLimit;
    }
    get getShortName() {
        return this.shortName;
    }
    get getName() {
        return this.name;
    }
}
export { SemiAutomaticFiring };
